import { Component, OnDestroy } from '@angular/core';
import { DialogControllerService } from '../../services/dialog-controller/dialog-controller.service';

export abstract class BaseViewComponent implements OnDestroy {
  isAlive = true;
  isPopupVisible = false;

  protected constructor(dialogId: string, private dialogController: DialogControllerService) {
    dialogController.activeDialogStream.subscribe(dialog => {
      const isVisible = dialog === dialogId;
      if (this.isPopupVisible !== isVisible) {
        this.isPopupVisible = isVisible;
        if (this.isPopupVisible) {
          this.onShow();
        } else {
          this.onHide();
        }
      }
    });
  }

  onShow() {}

  onHide() {}

  onButtonClick() {
    this.dialogController.closeDialog();
  }

  ngOnDestroy() {
    this.isAlive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base-view/base-view.component.ts